import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataListPage from "../../../components/DataListPage";
import TruncatedCell from "../../../components/TruncatedCell";
import faqService from "../../../services/faqService";
import { instanceToken } from "../../../utils/constant";

export default function FAQs() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [faqs, setFaqs] = useState(null);

  useEffect(() => {
    fetchFaqs(rowsPerPage, offset);
  }, [offset, rowsPerPage]);

  const fetchFaqs = async (limit, offsetValue) => {
    try {
      const res = await faqService.getAllFaqs(
        instanceToken.token,
        limit,
        offsetValue
      );
      setFaqs(res.data.faqs);
      setCount(res.data.count);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setOffset(0);
  };

  const openDetail = (row) => navigate(`/faqs/${row.id}`);

  const columns = [
    { id: "id", label: "ID", render: (row) => row.id },
    {
      id: "category_en",
      label: "Category (English)",
      render: (row) => <TruncatedCell value={row.category_en} />,
    },
    {
      id: "category_mm",
      label: "Category (Myanmar)",
      render: (row) => <TruncatedCell value={row.category_mm} myanmar />,
    },
    {
      id: "question_en",
      label: "Question (English)",
      render: (row) => <TruncatedCell value={row.question_en} />,
    },
    {
      id: "question_mm",
      label: "Question (Myanmar)",
      render: (row) => <TruncatedCell value={row.question_mm} myanmar />,
    },
    {
      id: "answers",
      label: "Number Of Answers",
      render: (row) => row.answers?.length ?? 0,
    },
  ];

  return (
    <DataListPage
      title="FAQs"
      rows={faqs || []}
      columns={columns}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      createButton={{
        label: "Create",
        onClick: () => navigate("/faqs/create-faq"),
      }}
      onView={openDetail}
      menuActions={[{ label: "View details", onClick: openDetail }]}
      loading={!faqs}
    />
  );
}
